class TrSiteLoader extends HTMLElement {
	selectors = {
		progress: '[data-tr-js-site-loader-progress]'
	};

	attributes = {
		minVisible: 'data-tr-js-site-loader-min-visible'
	};

	storage = {
		key: 'trSiteLoaderWasSeen',
		value: 'true'
	};

	stateClasses = {
		isLoaded: 'is-loaded'
	};

	connectedCallback() {
		this.progressElement = this.querySelector(this.selectors.progress);
		this.startedAt = Date.now();
		this.hideTimeout = null;

		this.init();
		this.bindEvents();
	}

	disconnectedCallback() {
		window.removeEventListener('load', this.onWindowLoad);

		this.destroy();
	}

	init() {
		if (this.wasSeen()) {
			this.hideImmediately();
			return;
		}

		document.documentElement.classList.add('tr-site-loader-is-visible');

		if (this.progressElement) {
			this.progressElement.style.transform = 'scaleX(0.75)';
		}
	}

	bindEvents() {
		if (this.wasSeen()) return;

		if (document.readyState === 'complete') {
			this.onWindowLoad();
			return;
		}

		window.addEventListener('load', this.onWindowLoad);
	}

	onWindowLoad = () => {
		const minVisible = Number(this.getAttribute(this.attributes.minVisible)) || 0;
		const visibleTime = Date.now() - this.startedAt;
		const delay = Math.max(minVisible - visibleTime, 0);

		if (this.progressElement) {
			this.progressElement.style.transform = 'scaleX(1)';
		}

		this.hideTimeout = window.setTimeout(() => {
			this.saveSeenState();
			this.classList.add(this.stateClasses.isLoaded);
			document.documentElement.classList.remove('tr-site-loader-is-visible');
			document.documentElement.classList.add('tr-site-loader-is-loaded');
		}, delay);
	};

	hideImmediately() {
		this.classList.add(this.stateClasses.isLoaded);
		document.documentElement.classList.remove('tr-site-loader-is-visible');
		document.documentElement.classList.add('tr-site-loader-is-loaded');
	}

	wasSeen() {
		try {
			return sessionStorage.getItem(this.storage.key) === this.storage.value;
		} catch {
			return false;
		}
	}

	saveSeenState() {
		try {
			sessionStorage.setItem(this.storage.key, this.storage.value);
		} catch {
			return false;
		}
	}

	destroy() {
		if (this.hideTimeout) {
			window.clearTimeout(this.hideTimeout);
			this.hideTimeout = null;
		}

		document.documentElement.classList.remove('tr-site-loader-is-visible');
	}
}

if (!customElements.get('tr-site-loader')) {
	customElements.define('tr-site-loader', TrSiteLoader);
}
